import { render, staticRenderFns } from "./ExpandCard.vue?vue&type=template&id=75f54ec8&lang=pug&"
import script from "./ExpandCard.vue?vue&type=script&lang=js&"
export * from "./ExpandCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports